import React from 'react'
import {type PlayerColor} from '@colonist/game-states'
// eslint-disable-next-line no-restricted-imports
import {GameColor} from '../../../../../code/client/shared/scripts/GameColor.ts'
import styles from './UIGameTimerBar.module.scss'
import clsx from 'clsx'

export interface UIGameTimerBarProps {
    className?: string
    currentTurnPlayerColor: PlayerColor
    timeLeftPercentage: number
    isAnimated: boolean
}

// TODO: className input should have bottom: var(--safe-area-inset-bottom) when called from the mobile app
export function UIGameTimerBar({
    className,
    currentTurnPlayerColor,
    timeLeftPercentage,
    isAnimated,
}: UIGameTimerBarProps) {
    const backgroundColor = GameColor.getPlayerBGDarkHashForMobile(currentTurnPlayerColor)
    const tickerStyle: React.CSSProperties = {
        backgroundColor: backgroundColor,
        width: `${timeLeftPercentage}%`,
    }

    return (
        <div className={clsx(styles.timerBarParent, className)}>
            <div
                className={clsx(styles.timerBar, isAnimated ? styles.active : '')}
                style={tickerStyle}>
            </div>
        </div>
    )
}
